import { Link } from "react-router-dom";

export default function Nav() {
  const handleLogout = () => {
    localStorage.removeItem('token')
    window.location.reload()
  }


  return (
    <> {localStorage.getItem('token') ? 
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
            <Link to="/">
            <p className="navbar-brand">Synema</p>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            </Link>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link to="/">
                    <p className="nav-link active" aria-current="page">Home</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/addmovie">
                    <p className="nav-link">Add Movie</p>
                  </Link>
                </li>
                <li className="nav-item" onClick={handleLogout}>
                  <p className="nav-link">Logout</p>
                </li>
              </ul>
            </div>
          </div>
        </nav> :
        <nav className="navbar navbar-expand-lg navbar-light bg-light"></nav>
    }
    </>
  )
  
};
